<template>
  <div
      class="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 text-slate-100 p-4 md:p-6"
      dir="rtl"
  >
    <div class="max-w-7xl mx-auto">
      <div
          v-if="!canUsePage"
          class="rounded-3xl border border-rose-400/30 bg-rose-500/10 p-2 text-rose-200 text-sm"
      >
        شما اجازه ثبت خروج دستی کالا را ندارید.
      </div>

      <div class="grid grid-cols-1 xl:grid-cols-[1fr_320px] gap-5">
        <main class="space-y-5">
          <!-- Header -->
          <section v-if="false" class="rounded-[2rem] border border-white/10 bg-white/[0.04] backdrop-blur-xl p-2 shadow-2xl">
            <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              <div>

                <p class="font-bold text-slate-400 ">
                  ثبت درخواست خروج کالا
                </p>
              </div>

              <div  v-if="false" class="grid grid-cols-2 gap-3 min-w-[240px]">
                <div class="rounded-2xl bg-slate-950/70 border border-white/10 p-4">
                  <div class=" text-slate-500">ردیف‌ها</div>
                  <div class=" font-black text-amber-300 mt-1">
                    {{ cartItems.length }}
                  </div>
                </div>

                <div class="rounded-2xl bg-slate-950/70 border border-white/10 p-4">
                  <div class="text-xs text-slate-500">جمع خروج</div>
                  <div class="text-2xl font-black text-emerald-300 mt-1">
                    {{ totalQuantity }}
                  </div>
                </div>
              </div>
            </div>
          </section>

          <!-- Notice -->
          <transition name="fade">
            <div
                v-if="notice"
                class="rounded-2xl border border-emerald-400/40 bg-emerald-500/10 px-5 py-4 text-emerald-100 text-sm"
            >
              {{ notice }}
            </div>
          </transition>

          <!-- Partner Selector -->
          <section
              v-if="mustSelectPartner"
              class="rounded-[2rem] border border-white/10 bg-white/[0.04] backdrop-blur-xl p-5 shadow-2xl"
          >
            <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-4">
              <div>
                <h2 class="text-base font-bold text-white">
                  انتخاب پارتنر
                </h2>
                <p class="text-xs text-slate-400 mt-1">
                  برای مدیر و صندوق‌دار انتخاب پارتنر قبل از جستجوی کالا الزامی است.
                </p>
              </div>

              <span
                  class="self-start md:self-auto rounded-full px-3 py-1 text-xs border"
                  :class="selectedPartner ? 'border-emerald-400/30 bg-emerald-500/10 text-emerald-200' : 'border-amber-400/30 bg-amber-500/10 text-amber-200'"
              >
                {{ selectedPartner ? 'پارتنر انتخاب شده' : 'در انتظار انتخاب' }}
              </span>
            </div>

            <div class="relative">
              <select
                  v-model="selectedPartner"
                  :disabled="loading.partners || cartItems.length > 0"
                  class="partner-select"
              >
                <option value="">
                  انتخاب پارتنر...
                </option>

                <option
                    v-for="p in partners"
                    :key="p.id"
                    :value="p.id"
                >
                  {{ partnerOptionLabel(p) }}
                </option>
              </select>

              <div class="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400">
                ▼
              </div>
            </div>

            <div
                v-if="cartItems.length"
                class="mt-3 rounded-2xl border border-amber-400/20 bg-amber-400/10 px-4 py-3 text-xs text-amber-200"
            >
              برای تغییر پارتنر، ابتدا لیست کالاهای انتخاب‌شده را خالی کنید.
            </div>
          </section>

          <!-- Search -->
          <section class="rounded-[2rem] border border-amber-400/20 bg-slate-900/80 p-5 shadow-2xl">
            <label class="block text-sm font-bold text-slate-200 mb-3">
              جستجوی کالا / بارکدخوان
            </label>

            <div class="relative">
              <input
                  ref="searchInput"
                  v-model="searchQuery"
                  type="text"
                  :disabled="!canSearchProducts"
                  class="w-full rounded-3xl border border-amber-400/40 bg-slate-950/90 px-5 py-5 pl-24 text-right text-sm text-slate-50 placeholder-slate-500 focus:outline-none focus:border-amber-400 focus:ring-4 focus:ring-amber-400/10 disabled:opacity-50 disabled:cursor-not-allowed"
                  :placeholder="mustSelectPartner && !selectedPartner ? 'اول پارتنر را انتخاب کنید...' : 'نام محصول، SKU یا کد ۱۶ رقمی...'"
              />

              <button
                  v-if="searchQuery"
                  @click="clearSearch"
                  class="absolute left-4 top-1/2 -translate-y-1/2 px-3 py-2 rounded-xl bg-slate-800 text-xs text-slate-300 hover:bg-slate-700"
              >
                پاک کردن
              </button>
            </div>

            <p class="text-xs text-slate-500 mt-3">
              با اسکن بارکد، فیلد جستجو به‌صورت خودکار پر می‌شود.
            </p>
          </section>

          <!-- Description -->

          <!-- Cart -->
          <section class="rounded-[2rem] border border-white/10 bg-white/[0.04] backdrop-blur-xl overflow-hidden shadow-2xl">
            <div class="px-5 py-4 border-b border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
              <div>
                <h2 class="text-lg font-black text-white">
                  آیتم‌های خروج
                </h2>
                <p class="text-xs text-slate-400 mt-1">
                  فقط تعداد ثبت می‌شود؛ قیمت و مبلغ در این بخش دخیل نیست.
                </p>
              </div>

              <button
                  v-if="cartItems.length"
                  @click="clearCart"
                  class="px-4 py-2 rounded-2xl bg-rose-500/15 text-rose-200 border border-rose-400/30 text-xs hover:bg-rose-500/25"
              >
                خالی کردن لیست
              </button>
            </div>

            <div class="overflow-auto">
              <table class="w-full text-sm min-w-[780px]">
                <thead class="bg-slate-950/90 text-slate-300 sticky top-0 z-10">
                <tr>
                  <th class="px-4 py-4 text-right">کالا</th>
                  <th class="px-4 py-4 text-center">موجودی</th>
                  <th class="px-4 py-4 text-center">تعداد خروج</th>
                  <th class="px-4 py-4 text-center">عملیات</th>
                </tr>
                </thead>

                <tbody class="divide-y divide-white/5">
                <tr
                    v-for="(item, idx) in cartItems"
                    :key="item._key"
                    class="hover:bg-slate-800/40 transition"
                >
                  <td class="px-4 py-4">
                    <div class="flex items-center gap-3">
                      <div class="w-14 h-14 rounded-2xl bg-slate-800 overflow-hidden border border-white/10 flex-shrink-0">
                        <img
                            v-if="item.product.image"
                            :src="img_source(item.product.image)"
                            class="w-full h-full object-cover"
                        />
                        <div v-else class="w-full h-full flex items-center justify-center text-[10px] text-slate-500">
                          کالا
                        </div>
                      </div>

                      <div class="min-w-0">
                        <div class="text-sm font-bold text-slate-50 truncate max-w-[420px]">
                            <span v-if="item.product.variation_of_name">
                              {{ item.product.variation_of_name }} :
                            </span>
                          {{ item.product.name }}
                        </div>

                        <div class="flex flex-wrap gap-2 mt-2 text-xs">
                            <span class="rounded-lg bg-slate-950 border border-white/10 px-2 py-1 text-slate-400">
                              {{ item.product.sixteen_digit_code || '---' }}
                            </span>
                        </div>
                      </div>
                    </div>
                  </td>

                  <td class="px-4 py-4 text-center">
                      <span class="inline-flex min-w-[54px] justify-center rounded-xl border border-emerald-400/20 bg-emerald-500/10 px-3 py-2 text-emerald-300 font-black">
                        {{ item.inventory_count }}
                      </span>
                  </td>

                  <td class="px-4 py-4 text-center">
                    <div class="inline-flex items-center rounded-2xl border border-amber-400/30 overflow-hidden bg-slate-950">
                      <button
                          @click="changeQuantity(idx, item.quantity - 1)"
                          class="w-11 h-11 bg-slate-800 hover:bg-slate-700 text-lg text-center items-center"
                      >
                        -
                      </button>

                      <input
                          type="number"
                          min="1"
                          :max="item.inventory_count"
                          v-model.number="item.quantity"
                          @change="onQuantityInput(idx)"
                          class="w-20 text-center bg-slate-950 py-3 text-slate-50 focus:outline-none"
                      />

                      <button
                          @click="changeQuantity(idx, item.quantity + 1)"
                          class="w-11 h-11 bg-slate-800 hover:bg-slate-700 text-lg text-center items-center"
                      >
                        +
                      </button>
                    </div>
                  </td>

                  <td class="px-4 py-4 text-center">
                    <button
                        @click="removeItem(idx)"
                        class="px-4 py-2 rounded-2xl bg-rose-500/15 text-rose-200 border border-rose-400/30 text-xs hover:bg-rose-500/25"
                    >
                      حذف
                    </button>
                  </td>
                </tr>

                <tr v-if="!cartItems.length">
                  <td colspan="4" class="px-6 py-20 text-center">
                    <div class="mx-auto w-16 h-16 rounded-3xl border border-white/10 bg-slate-950 flex items-center justify-center text-slate-500 mb-4">
                      +
                    </div>
                    <div class="text-slate-400 font-bold">
                      هنوز کالایی انتخاب نشده است.
                    </div>
                    <div class="text-xs text-slate-600 mt-2">
                      از بخش جستجو یا بارکدخوان کالا اضافه کنید.
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </section>

          <!-- Last Created -->
          <section
              v-if="lastExit"
              class="rounded-[2rem] border border-emerald-400/20 bg-emerald-500/10 p-5"
          >
            <div class="text-sm text-emerald-200 font-bold">
              درخواست خروج ثبت شد.
            </div>

            <div class="text-xs text-emerald-100/80 mt-2">
              شماره درخواست: {{ lastExit.id }} —
              وضعیت: {{ statusLabel(lastExit.status) }}
            </div>
          </section>
        </main>

        <!-- Sticky Summary -->
        <aside class="xl:sticky xl:top-6 h-fit space-y-4">
          <section class="rounded-[2rem] border border-white/10 bg-slate-950/90 backdrop-blur-xl p-5 shadow-2xl">
            <div class="flex items-center justify-between mb-5">
              <h3 class="text-base font-black text-white">
                خلاصه درخواست
              </h3>

            </div>

            <div class="space-y-3">
              <div class="summary-row">
                <span>تعداد ردیف</span>
                <strong class="text-amber-300">{{ cartItems.length }}</strong>
              </div>

              <div class="summary-row">
                <span>جمع تعداد خروج</span>
                <strong class="text-emerald-300">{{ totalQuantity }}</strong>
              </div>

              <div class="summary-row">
                <span>وضعیت پارتنر</span>
                <strong :class="mustSelectPartner && !selectedPartner ? 'text-amber-300' : 'text-emerald-300'">
                  {{ mustSelectPartner ? (selectedPartner ? 'انتخاب شده' : 'انتخاب نشده') : 'خود پارتنر' }}
                </strong>
              </div>
              <div class="description-row">
                  <textarea
                      v-model="description"
                      rows="3"
                      class="w-full rounded-3xl  px-5 py-4 text-sm text-amber-300 placeholder-slate-400 focus:outline-none focus:border-amber-400/60 focus:ring-4 focus:ring-amber-400/10"
                      placeholder="توضیحات..."
                  ></textarea>
              </div>
            </div>

            <button
                @click="submitExit"
                :disabled="!canUsePage || (mustSelectPartner && !selectedPartner) || !cartItems.length || loading.submit"
                class="w-full mt-5 px-5 py-4 rounded-3xl bg-gradient-to-r from-amber-400 to-pink-500 text-slate-950 text-sm font-black disabled:opacity-50 disabled:cursor-not-allowed shadow-lg shadow-amber-500/10"
            >
              {{ loading.submit ? 'در حال ثبت...' : 'ثبت درخواست خروج' }}
            </button>

          </section>
        </aside>
      </div>
    </div>

    <!-- Search Modal -->
    <transition name="fade">
      <div
          v-if="searchQuery && (searchLoading || searchResults.length)"
          class="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-xl p-4"
      >
        <div class="w-full max-w-5xl rounded-[2rem] border border-amber-400/30 bg-slate-950 overflow-hidden shadow-2xl">
          <div class="p-5 border-b border-white/10 space-y-4">
            <div class="flex items-center justify-between gap-4">
              <div>
                <div class="text-sm font-bold text-slate-100">
                  نتایج جستجو
                </div>

                <div class="text-xs text-slate-400 mt-1">
                  <span v-if="searchLoading">در حال جستجو...</span>
                  <span v-else>
                    <span class="text-amber-300 font-black">{{ filteredSearchResults.length }}</span>
                    نتیجه از
                    <span class="text-slate-100 font-black">{{ searchResults.length }}</span>
                  </span>
                </div>
              </div>

              <button
                  @click="closeSearchPopup"
                  class="rounded-2xl border border-white/10 bg-slate-900 px-4 py-2 text-xs text-slate-300 hover:text-white hover:bg-slate-800"
              >
                بستن ✕
              </button>
            </div>

            <div v-if="!searchLoading" class="relative">
              <input
                  ref="popupNameSearchInput"
                  v-model="popupNameSearch"
                  type="text"
                  class="w-full rounded-3xl border border-amber-400/25 bg-slate-900/80 px-5 py-4 pl-24 text-right text-sm text-slate-50 placeholder-slate-500 focus:outline-none focus:border-amber-400/70 focus:ring-4 focus:ring-amber-400/10"
                  placeholder="فیلتر سریع بین همین نتایج بر اساس نام، SKU یا کد..."
                  @keydown.stop
                  @keyup.stop
                  @keypress.stop
              />

              <button
                  v-if="popupNameSearch"
                  @click="popupNameSearch = ''"
                  class="absolute left-4 top-1/2 -translate-y-1/2 px-3 py-2 rounded-xl bg-slate-800 text-xs text-slate-300"
              >
                پاک کردن
              </button>
            </div>
          </div>

          <div class="max-h-[72vh] overflow-y-auto divide-y divide-white/5">
            <button
                v-for="(p, idx) in filteredSearchResults"
                :key="p.id"
                :ref="'searchItem_' + idx"
                @click="selectSearchProduct(p)"
                @mouseenter="selectedSearchIndex = idx"
                :disabled="!canAddProduct(p)"
                class="w-full text-right px-5 py-4 flex gap-4 hover:bg-slate-800/80 transition disabled:opacity-50 disabled:cursor-not-allowed search-result-item"
                :class="selectedSearchIndex === idx ? 'bg-slate-800/80 border-r-4 border-amber-400' : ''"
            >
              <div class="w-16 h-16 rounded-2xl bg-slate-800 overflow-hidden border border-white/10 flex-shrink-0">
                <img
                    v-if="p.image"
                    :src="img_source(p.image)"
                    class="w-full h-full object-cover"
                />
                <div v-else class="w-full h-full flex items-center justify-center text-slate-500 text-xs">
                  کالا
                </div>
              </div>

              <div class="flex-1 min-w-0">
                <div class="text-sm font-black text-slate-50 truncate">
                  <span v-if="p.variation_of_name">{{ p.variation_of_name }} : </span>
                  {{ p.name }}
                </div>

                <div class="flex flex-wrap gap-2 mt-3 text-xs">
                  <span class="bg-slate-900 border border-white/10 px-2 py-1 rounded-lg text-slate-400">
                    کد: {{ p.sixteen_digit_code || '---' }}
                  </span>

                  <span
                      class="px-2 py-1 rounded-lg border"
                      :class="canAddProduct(p)
                      ? 'bg-emerald-500/10 text-emerald-300 border-emerald-400/20'
                      : 'bg-rose-500/10 text-rose-300 border-rose-400/20'"
                  >
                    موجودی: {{ p.inventory_count || 0 }}
                  </span>

                  <span class="bg-slate-900 border border-white/10 px-2 py-1 rounded-lg text-slate-400">
                    راهرو: {{ p.aisle || '-' }}
                  </span>

                  <span class="bg-slate-900 border border-white/10 px-2 py-1 rounded-lg text-slate-400">
                    قفسه: {{ p.shelf_number || '-' }}
                  </span>
                </div>
              </div>

              <div v-if="canAddProduct(p)" class="flex items-center">
                <div class="w-10 h-10 rounded-2xl bg-amber-400 text-slate-950 flex items-center justify-center font-black text-xl">
                  +
                </div>
              </div>
            </button>

            <div
                v-if="!searchLoading && !filteredSearchResults.length"
                class="p-12 text-center text-slate-500"
            >
              نتیجه‌ای یافت نشد
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'PartnerStockExitCreate',

  data() {
    return {
      popupNameSearch: '',
      notice: '',

      currentUser: this.user || {},
      partners: [],
      selectedPartner: '',

      searchQuery: '',
      searchLoading: false,
      searchResults: [],
      selectedSearchIndex: -1,
      debouncedSearchFn: null,

      cartItems: [],
      description: '',

      loading: {
        submit: false,
        partners: false,
      },

      lastExit: null,
    }
  },

  computed: {
    isPartnerUser() {
      return this.user && this.user.user_type === 'prtnr'
    },

    isManagerUser() {
      return this.user && this.user.user_type === 'ma'
    },

    isCashierUser() {
      return this.user && this.user.user_type === 'cshr'
    },

    canUsePage() {
      return this.isPartnerUser || this.isManagerUser || this.isCashierUser
    },

    mustSelectPartner() {
      return this.isManagerUser || this.isCashierUser
    },

    canSearchProducts() {
      if (!this.canUsePage) return false
      if (this.mustSelectPartner && !this.selectedPartner) return false
      return true
    },

    filteredSearchResults() {
      const q = (this.popupNameSearch || '').trim().toLowerCase()

      if (!q) return this.searchResults

      return this.searchResults.filter(p => {
        const name = `${p.variation_of_name || ''} ${p.name || ''}`.toLowerCase()
        const code = `${p.sku || ''} ${p.sixteen_digit_code || ''}`.toLowerCase()

        return name.includes(q) || code.includes(q)
      })
    },

    totalQuantity() {
      return this.cartItems.reduce((sum, item) => {
        return sum + (Number(item.quantity) || 0)
      }, 0)
    },
  },

  watch: {
    selectedPartner() {
      this.clearSearch()
      this.clearCart()
      this.lastExit = null
    },

    searchQuery(val) {
      if (!val || val.length < 2) {
        this.searchResults = []
        this.popupNameSearch = ''
        this.selectedSearchIndex = -1
        return
      }

      if (this.debouncedSearchFn) {
        this.debouncedSearchFn(val)
      } else {
        this.searchProducts(val)
      }
    },

    popupNameSearch() {
      this.selectedSearchIndex = -1
    },
  },

  created() {
    this.debouncedSearchFn = this.debounce(this.searchProducts, 300)

    if (this.mustSelectPartner) {
      this.fetchPartners()
    }
  },

  mounted() {
    document.title = 'اکسونی | خروج دستی کالا'
    window.addEventListener('keydown', this.handleScannerInput)
    window.addEventListener('keydown', this.handleKeyboardNavigation)

    this.$nextTick(() => {
      if (this.$refs.searchInput) this.$refs.searchInput.focus()
    })
  },

  beforeDestroy() {
    window.removeEventListener('keydown', this.handleScannerInput)
    window.removeEventListener('keydown', this.handleKeyboardNavigation)
  },

  methods: {
    apiGetPartnerStock(path, params) {
      return new Promise((resolve, reject) => {
        this.request({
          url: this.endpoint(`partner-stock/${path}`),
          method: 'get',
          params: this.cleanParams(params || {}),
          success: data => resolve(data),
          error: err => reject(err),
        })
      })
    },

    async fetchPartners() {
      if (!this.mustSelectPartner) return

      this.loading.partners = true

      try {
        const data = await this.apiGetPartnerStock('partnerList', {})
        this.partners = data.results || data || []
      } catch (e) {
        console.error('fetchPartners error:', e)
        this.partners = []
        this.toast('خطا در دریافت لیست پارتنرها')
      } finally {
        this.loading.partners = false
      }
    },

    partnerOptionLabel(p) {
      return (
          p.shop_name ||
          p.name ||
          p.title ||
          p.full_name ||
          p.username ||
          `Partner #${p.id}`
      )
    },

    closeSearchPopup() {
      this.searchQuery = ''
      this.popupNameSearch = ''
      this.searchResults = []
      this.selectedSearchIndex = -1

      if (this.$refs.searchInput) {
        this.$refs.searchInput.blur()
      }
    },

    clearSearch() {
      this.closeSearchPopup()
    },

    async searchProducts(query) {
      const q = (query || '').trim()

      if (!this.canUsePage) {
        this.toast('شما اجازه ثبت خروج دستی کالا را ندارید')
        return
      }

      if (!this.canSearchProducts) {
        this.toast('ابتدا پارتنر را انتخاب کنید')
        this.clearSearch()
        return
      }

      if (!q || q.length < 2) return

      this.searchLoading = true
      this.popupNameSearch = ''
      this.selectedSearchIndex = -1

      try {
        const params = {
          suffix: q,
        }

        if (this.mustSelectPartner && this.selectedPartner) {
          params.partner_id = this.selectedPartner
        }

        const data = await this.apiGetPos('products/search/', params)
        this.searchResults = data.results || data || []
      } catch (e) {
        console.error('searchProducts error:', e)
        this.toast('خطا در جستجوی کالا')
      } finally {
        this.searchLoading = false
      }
    },

    toast(msg) {
      this.notice = msg
      setTimeout(() => {
        this.notice = ''
      }, 3000)
    },

    cleanParams(obj) {
      const copy = { ...(obj || {}) }
      Object.keys(copy).forEach(k => {
        if (copy[k] === '' || copy[k] === null || copy[k] === undefined) {
          delete copy[k]
        }
      })
      return copy
    },

    selectSearchProduct(product) {
      if (!this.canAddProduct(product)) return
      this.addProductToCart(product)
    },

    apiGetPos(path, params) {
      return new Promise((resolve, reject) => {
        this.request({
          url: this.endpoint(`pos/v1/${path}`),
          method: 'get',
          params: this.cleanParams(params || {}),
          success: data => resolve(data),
          error: err => reject(err),
        })
      })
    },

    apiPostPos(path, data) {
      return new Promise((resolve, reject) => {
        this.request({
          url: this.endpoint(`partner-stock/${path}`),
          method: 'post',
          data: this.cleanParams(data || {}),
          success: data => resolve(data),
          error: err => reject(err),
        })
      })
    },

    debounce(fn, delay) {
      let timeout
      return (...args) => {
        clearTimeout(timeout)
        timeout = setTimeout(() => fn.apply(this, args), delay)
      }
    },

    canAddProduct(product) {
      return product && Number(product.inventory_count || 0) > 0
    },

    addProductToCart(product) {
      const stock = Number(product.inventory_count || 0)

      if (stock <= 0) {
        this.toast('این کالا موجودی ندارد')
        return
      }

      const existing = this.cartItems.find(
          item => item.product && item.product.id === product.id
      )

      if (existing) {
        if (existing.quantity >= stock) {
          this.toast('بیشتر از موجودی انبار نمی‌توان خروج زد')
          this.clearSearch()
          return
        }

        existing.quantity += 1
      } else {
        this.cartItems.unshift({
          _key: `${product.id}-${Date.now()}-${Math.random()}`,
          product,
          quantity: 1,
          inventory_count: stock,
        })
      }

      this.clearSearch()

      this.$nextTick(() => {
        if (this.$refs.searchInput) this.$refs.searchInput.focus()
      })
    },

    changeQuantity(idx, newQty) {
      const item = this.cartItems[idx]
      if (!item) return

      const stock = Number(item.inventory_count || 0)

      if (!newQty || newQty <= 0) {
        this.removeItem(idx)
        return
      }

      if (newQty > stock) {
        newQty = stock
        this.toast('تعداد خروج بیشتر از موجودی نیست')
      }

      item.quantity = newQty
    },

    onQuantityInput(idx) {
      const item = this.cartItems[idx]
      if (!item) return

      let q = Number(item.quantity || 0)
      const stock = Number(item.inventory_count || 0)

      if (q <= 0) {
        this.removeItem(idx)
        return
      }

      if (q > stock) {
        q = stock
        this.toast('تعداد خروج بیشتر از موجودی نیست')
      }

      item.quantity = q
    },

    removeItem(idx) {
      this.cartItems.splice(idx, 1)
    },

    clearCart() {
      this.cartItems = []
    },

    buildExitPayload() {
      const payload = {
        description: this.description || null,
        items: this.cartItems.map(item => ({
          product: item.product.id,
          quantity: Number(item.quantity || 0),
        })),
      }

      if (!this.isPartnerUser && this.selectedPartner) {
        payload.partner = Number(this.selectedPartner)
      }

      return payload
    },

    validateBeforeSubmit() {
      if (!this.canUsePage) {
        this.toast('شما اجازه ثبت خروج دستی کالا را ندارید')
        return false
      }

      if (!this.isPartnerUser && !this.selectedPartner) {
        this.toast('ابتدا پارتنر را انتخاب کنید')
        return false
      }

      if (!this.cartItems.length) {
        this.toast('هیچ کالایی انتخاب نشده')
        return false
      }

      for (const item of this.cartItems) {
        const q = Number(item.quantity || 0)
        const stock = Number(item.inventory_count || 0)

        if (q <= 0) {
          this.toast('تعداد خروج باید بزرگ‌تر از صفر باشد')
          return false
        }

        if (q > stock) {
          this.toast(`تعداد خروج ${item.product.name} بیشتر از موجودی است`)
          return false
        }
      }

      return true
    },

    async submitExit() {
      if (!this.validateBeforeSubmit()) return

      this.loading.submit = true

      try {
        const payload = this.buildExitPayload()
        const created = await this.apiPostPos('partner-stock-exits/', payload)

        this.lastExit = created
        this.toast('درخواست خروج ثبت شد')

        this.clearCart()
        this.description = ''

        this.$router.push({
          name: 'PartnerStockExitManager',
          query: {
            exit_id: created.id,
            open: '1',
          },
        })
      } catch (e) {
        console.error('submitExit error:', e)
        this.toast('خطا در ثبت درخواست خروج')
      } finally {
        this.loading.submit = false
      }
    },

    handleScannerInput(e) {
      if (!this.canSearchProducts) {
        return
      }

      const active = document.activeElement

      if (active === this.$refs.popupNameSearchInput) {
        return
      }

      const tag = active && active.tagName
      const isInput = tag === 'INPUT' || tag === 'TEXTAREA'

      if (isInput && active !== this.$refs.searchInput) {
        return
      }

      if (this.$refs.searchInput && active !== this.$refs.searchInput) {
        this.$refs.searchInput.focus()
      }

      if (e.key.length === 1) {
        e.preventDefault()
        this.searchQuery += e.key
      }

      if (e.key === 'Enter') {
        e.preventDefault()
        this.onSearchEnter()
      }
    },

    async onSearchEnter() {
      const q = (this.searchQuery || '').trim()
      if (!q) return

      await this.searchProducts(q)

      if (this.searchResults.length === 1) {
        const p = this.searchResults[0]
        if (this.canAddProduct(p)) {
          this.addProductToCart(p)
        } else {
          this.toast('این کالا موجودی ندارد')
        }
      }
    },

    handleKeyboardNavigation(e) {
      const active = document.activeElement

      if (active === this.$refs.popupNameSearchInput) {
        if (e.key === 'Escape') {
          e.preventDefault()
          this.closeSearchPopup()
        }
        return
      }

      const results = this.filteredSearchResults || []

      if (this.searchQuery && results.length) {
        if (e.key === 'ArrowDown') {
          e.preventDefault()
          this.selectedSearchIndex = Math.min(
              this.selectedSearchIndex + 1,
              results.length - 1
          )
          this.scrollToSelectedItem()
          return
        }

        if (e.key === 'ArrowUp') {
          e.preventDefault()
          this.selectedSearchIndex = Math.max(this.selectedSearchIndex - 1, -1)
          this.scrollToSelectedItem()
          return
        }

        if (e.key === 'Enter' && this.selectedSearchIndex >= 0) {
          e.preventDefault()
          const selectedProduct = results[this.selectedSearchIndex]
          if (this.canAddProduct(selectedProduct)) {
            this.addProductToCart(selectedProduct)
          }
          return
        }
      }

      if (e.key === 'Escape') {
        this.closeSearchPopup()
      }
    },

    scrollToSelectedItem() {
      this.$nextTick(() => {
        const items = document.querySelectorAll('.search-result-item')
        if (items[this.selectedSearchIndex]) {
          items[this.selectedSearchIndex].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
          })
        }
      })
    },

    statusLabel(status) {
      const map = {
        draft: 'در انتظار تأیید',
        dr: 'در انتظار تأیید',
        confirmed: 'تأیید شده',
        cf: 'تأیید شده',
        cancelled: 'لغو شده',
        ca: 'لغو شده',
      }

      return map[status] || status || 'در انتظار تأیید'
    },

    logout() {
      this.setToken('')
      this.$store.commit('setUser', null)

      if (this.$route.name !== 'Login') {
        const url = this.$router.resolve({ name: 'Login' })
        window.location = url.href || url
      }

      this.tabEmit && this.tabEmit('logout')
    },
  },
}
</script>

<style scoped>
.partner-select {
  width: 100%;
  appearance: none;
  border-radius: 1.5rem;
  border: 1px solid rgba(251, 191, 36, 0.35);
  background: rgba(2, 6, 23, 0.85);
  padding: 1rem 1.25rem;
  padding-left: 3rem;
  color: #f8fafc;
  font-size: 0.875rem;
  outline: none;
  transition: all 0.2s ease;
}

.partner-select:focus {
  border-color: rgba(251, 191, 36, 0.75);
  box-shadow: 0 0 0 4px rgba(251, 191, 36, 0.1);
}

.partner-select:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.summary-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  border-radius: 1.25rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(15, 23, 42, 0.7);
  padding: 0.9rem 1rem;
  color: #94a3b8;
  font-size: 0.8rem;
}

.description-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  border-radius: 1.25rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(15, 23, 42, 0.7);
  color: #94a3b8;
  font-size: 0.8rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>